import React from "react";
import useStyles from './styles.js';
import CopyrightIcon from '@material-ui/icons/Copyright';
import { Typography } from '@material-ui/core/';

const Footer = () => {
    const classes = useStyles();

    const currentYear = new Date().getFullYear();

    return <footer className={classes.footer}>
     <Typography variant="h6"> Copyright <CopyrightIcon fontSize="small" />{currentYear} </Typography>

    </footer>
}

export default Footer;